<template>
  <div class="custom-wrapper" :class="{active: visible || visible2 || visible3}">
    <div class="position: relative;">
      <!-- .custom-text-type-1 === ctt1 -->
      <popper :show-popper="visible" @close="visible=false" placement="right-start" :index="index">
        <div class="ctt1">
          <!-- <div style="word-break: break-all; white-space: pre-wrap;">{{pictureModal}}</div> -->
          <div class="ctt1-box custom-item">
            <div class="ctt1-box-content pictrue" @click.prevent="setVisible()">
              <template v-if="addList && addList.length">
                <div style="min-height: 200px;font-size:0;line-height: initial;">
                  <template v-if="pictureModal.type !== 2">
                    <div class="pic-line" v-for="(add, i) in addList" :key="'pic-line-' + i" :style="styleObj">
                      <img :src="add.data.url" width="100%" v-if="add.data.url" />
                      <img src="@assets/img/custom/pic-line2.png" width="100%" v-else />
                    </div>
                  </template>
                  <template v-else>
                    <div class="pic-swiper">
                      <Carousel loop :radius-dot="true" arrow="never">
                        <CarouselItem v-for="(add, idx) in addList" :key="'pic-line-' + idx">
                          <img :src="add.data.url" width="100%" v-if="add.data.url" />
                          <img src="@assets/img/custom/pic-line2.png" width="100%" v-else />
                        </CarouselItem>
                      </Carousel>
                    </div>
                  </template>
                </div>
              </template>
              <div class="empty" v-else>
                点击编辑图片广告
                <br />建议宽度750px
              </div>
            </div>
            <!-- 关闭按钮 -->
            <i class="icon iconfont icon-close-c custom-close" @click="close()"></i>
          </div>
        </div>
        <div slot="content" class="ctt1-poptip z-pictrue">
          <!-- <div style="word-break: break-all; white-space: pre-wrap;">{{index}}</div> -->
          <div class="ctt1p-title">图片设置</div>
          <div class="ctt1p-content">
            <div class="ctt1p-item">
              <div class="ctt1p-label">模板：</div>
              <div class="ctt1p-control">
                <div class="ctt1p-select-templates" v-for="(pic, num) in picArr" :key="'picArr-' + num" :class="{active: pictureModal.type === (num + 1)}" @click="changeTemplates(num)">
                  <div class="ctt1p-select-templates__img-block">
                    <img :src="pic.img" />
                  </div>
                  <p>{{pic.txt}}</p>
                </div>
              </div>
            </div>
            <div class="ctt1p-item" style="margin-bottom: 20px;">
              <div class="ctt1p-label">添加图片：</div>
              <div class="ctt1p-control">
                <div class="ctt1p-pic-add">
                  <div class="ctt1p-pic-add__title">最多添加5张图片</div>
                  <div class="ctt1p-pic-add__item" v-for="(item, idx) in addList" :key="'addList' + idx">
                    <addPictureItem :ref="'addPictureItem' + idx" v-model="item.data" @changModal="changModal($event, idx)"></addPictureItem>

                    <i class="icon iconfont icon-close-c ctt1p-pic-add__item-close" @click="delPictureItem(idx)" :class="{first: idx === 0}"></i>
                  </div>
                  <div class="ctt1p-pic-add__btn" @click="addPic()" v-if="addList.length<=4">
                    <a href="javascript:void(0)">
                      <Icon type="md-add" />添加图片
                    </a>
                    <p>建议图片宽度为750px</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="ctt1p-item" style="align-items: center;margin-bottom: 20px;" v-if="this.pictureModal.type === 1">
              <div class="ctt1p-label">页面边距：</div>
              <div class="ctt1p-control">
                <div class="ctt1p-control-range">
                  <Slider show-input :max="30" v-model="pictureModal.padding"></Slider>
                </div>
              </div>
            </div>

            <div class="ctt1p-item" style="align-items: center;margin-bottom: 20px;" v-if="this.pictureModal.type === 1">
              <div class="ctt1p-label">图片边距：</div>
              <div class="ctt1p-control">
                <div class="ctt1p-control-range">
                  <Slider show-input :max="30" v-model="pictureModal.spacing"></Slider>
                </div>
              </div>
            </div>
            <div style="text-align:right;">
              <Button type="primary" @click.prevent="setVisible()">暂存</Button>
            </div>
          </div>
        </div>
      </popper>
      <!-- 上方增加键 -->
      <Poptip v-model="visible2" placement="right-start" width="411" class="custom-add-wrapper z-top">
        <img src="@/assets/img/custom/add.png" />
        <div slot="content" class="ctt1-poptip">
          <div class="ct-components">
            <div class="ctc-title">新增组件</div>
            <div class="ctc-group" v-if="commmonType===1">
              <div class="ctc-item" v-for="(item, index) in commmonArr" :key="'commmon-' + index" @click="add(item, 'top')">
                <i class="icon iconfont" :class="item.icon"></i>
                <div class="ctc-item-txt">{{item.title}}</div>
              </div>
            </div>
            <div class="ctc-group" v-if="commmonType===2">
              <div class="ctc-item" v-for="(item, index) in commmonArr2" :key="'commmon-' + index" @click="add(item, 'top')">
                <i class="icon iconfont" :class="item.icon"></i>
                <div class="ctc-item-txt">{{item.title}}</div>
              </div>
            </div>
          </div>
        </div>
      </Poptip>
      <!-- 下方增加键 -->
      <Poptip v-model="visible3" placement="right-start" width="411" class="custom-add-wrapper z-bottom">
        <img src="@/assets/img/custom/add.png" />
        <div slot="content" class="ctt1-poptip">
          <div class="ct-components">
            <div class="ctc-title">新增组件</div>
            <div class="ctc-group" v-if="commmonType===1">
              <div class="ctc-item" v-for="(item, index) in commmonArr" :key="'commmon-' + index" @click="add(item, 'bottom')">
                <i class="icon iconfont" :class="item.icon"></i>
                <div class="ctc-item-txt">{{item.title}}</div>
              </div>
            </div>
            <div class="ctc-group" v-if="commmonType===2">
              <div class="ctc-item" v-for="(item, index) in commmonArr2" :key="'commmon-' + index" @click="add(item, 'bottom')">
                <i class="icon iconfont" :class="item.icon"></i>
                <div class="ctc-item-txt">{{item.title}}</div>
              </div>
            </div>
          </div>
        </div>
      </Poptip>
    </div>
  </div>
</template>

<script>
import addPictureItem from "./add-picture-item";
import { mapGetters, mapMutations } from "vuex";
import popper from "@components/vue-popper/VuePopper.vue";

export default {
  // 图片类型 1
  name: "custom-picture-type-1",
  model: {
    prop: "pictureModal",
    event: "sendPictureModal",
  },
  props: {
    pictureModal: {
      type: Object,
      default: function () {
        return {
          type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
          padding: 0, // 页面边距
          spacing: 0, // 图片边距
          list: [],
        };
      },
    },
    index: {
      type: Number,
      default: 0,
    },
    commmonType: {
      // 通用添加组件的列表   1：所有列表   2：筛选列表
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      picModal: {},
      picArr: [
        // 模板列表
        {
          txt: "一行一个",
          img: require("../../../../../assets/img/custom/pic-line.png"),
          active: true,
        },
        {
          txt: "轮播海报",
          img: require("../../../../../assets/img/custom/pic-swiper.png"),
          active: false,
        },
      ],
      addList: [
        // 模板列表
      ],

      imgName1: "",
      visible1: false,
      uploadList1: [],
      defaultList1: [],
      limitNum1: 1, // 图文显示的限制图片个数

      visible: false,
      visible2: false,
      visible3: false,

      commmonArr: [
        {
          title: "文本",
          icon: "icon-wenbenbianji",
          type: "text",
          componentName: "customText",
          config: {
            type: 1, // 文本类型 暂时只有 1
            content: "", // 文本内容
            fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色 默认黑色
            position: "left", // 文本对齐格式
          },
        },
        {
          title: "图片",
          icon: "icon-shangchuantupian",
          type: "picture",
          componentName: "customPicture",
          config: {
            type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
            padding: 0, // 页面边距
            spacing: 0, // 图片边距
            list: [
              {
                url: "",
                title: "",
                link: {
                  type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                  value: "",
                },
              },
            ],
          },
        },
        {
          title: "标题",
          icon: "icon-biaoti",
          type: "title",
          componentName: "customTitle",
          config: {
            type: 1, // 标题类型 暂时只有 1
            content: "",
            position: "left", // 文本对齐格式
            padding: "12px", // 标题的边距
            fontSize: "12px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色
            link: {
              type: "3",
              value: "",
            },
          },
        },
        {
          title: "链接",
          icon: "icon-link",
          type: "link",
          componentName: "customLink",
          config: [
            {
              type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
              name: "",
              url: "",
            },
          ],
        },
        {
          title: "产品搜索",
          icon: "icon-sousuo",
          type: "search",
          componentName: "customSearch",
          config: {
            type: 1, // 搜索类型 暂时只有 1
            words: ["热词1", "热词2"],
            style: "circular", // 搜索外边框样式 （圆 \ 方）
            position: "left", // 文本对齐格式
            color: "#ccc",
            background: "#f5f5f5",
            borderColor: "#91c0ec",
          },
        },
        {
          title: "视频",
          icon: "icon-shangchuanshipin",
          type: "video",
          componentName: "customVideo",
          config: {
            type: 1, // 文本类型 暂时只有 1
            cover: "", // 封面
            time: 5000, // 视频封面截取帧
            link: "", // 视频地址
            coverType: "0", // 视频封面累心 0 截取 1 自定义
          },
        },
      ],
      commmonArr2: [
        {
          title: "文本",
          icon: "icon-wenbenbianji",
          type: "text",
          componentName: "customText",
          config: {
            type: 1, // 文本类型 暂时只有 1
            content: "", // 文本内容
            fontSize: "16px", // 文字大小 （12px 14px 16px）===（大 中 小）
            color: "#000", // 文字颜色 默认黑色
            position: "left", // 文本对齐格式
          },
        },
        {
          title: "图片",
          icon: "icon-shangchuantupian",
          type: "picture",
          componentName: "customPicture",
          config: {
            type: 1, // 文本类型 1 = （list 列表形式） 2 =  (swiper 轮播模式)
            padding: 0, // 页面边距
            spacing: 0, // 图片边距
            list: [
              {
                url: "",
                title: "",
                link: {
                  type: "0", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
                  value: "",
                },
              },
            ],
          },
        },
        {
          title: "视频",
          icon: "icon-shangchuanshipin",
          type: "video",
          componentName: "customVideo",
          config: {
            type: 1, // 文本类型 暂时只有 1
            cover: "", // 封面
            time: 5000, // 视频封面截取帧
            link: "", // 视频地址
            coverType: "0", // 视频封面累心 0 截取 1 自定义
          },
        },
      ],
    };
  },
  watch: {
    activeIndex(val, oldVal) {
      if (val !== this.index) this.visible = false;
    },
    pictureModal(val, oldVal) {
      this.init();
    },
  },
  components: {
    addPictureItem,
    popper,
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      company: "loginModule/getCompany",
      activeIndex: "customComponentModule/getActiveIndex",
    }),
    styleObj() {
      return {
        paddingLeft: this.pictureModal.padding + "px",
        paddingRight: this.pictureModal.padding + "px",
        marginBottom: this.pictureModal.spacing + "px",
      };
    },
    hasImg() {
      let len = this.addList.length;
      this.addList;
    },
  },
  created() {
    this.init();
    if (this.index === this.activeIndex) {
      this.visible = true;
    }
  },
  methods: {
    ...mapMutations({
      setActiveIndex: "customComponentModule/setActiveIndex",
    }),
    init() {
      let arr = [];
      this.pictureModal.list.forEach((c, index) => {
        arr.push({
          modal: "addPictureItem" + index,
          data: c,
        });
      });
      this.addList = arr || [];
    },
    setVisible() {
      this.visible = !this.visible;
      this.setActiveIndex(this.index);
      this.popperHide();
    },
    addPic() {
      const num = this.addList.length;
      this.addList.push({
        modal: "addPictureItem" + num,
        data: {
          url: "",
          title: "",
          link: {
            type: "", // （0: 自定义, 1: 公司，2: 产品分组，3: 产品，4: 品牌, 5: 商机）
            value: "",
          },
        },
      });
    },
    changeTemplates(index) {
      console.log(index);
      this.pictureModal.type = index + 1;
      if (this.pictureModal.type === 2) {
        this.pictureModal.padding = 0; // 页面边距
        this.pictureModal.spacing = 0; // 图片边距
      }
    },
    popperHide() {
      let arr = [];
      this.addList.forEach((c) => {
        if (c.data.url) {
          arr.push(c.data);
        }
      });
      this.pictureModal.list = arr;
      this.$emit("sendPictureModal", this.pictureModal);
    },
    addComponent() {
      this.visible = false;
    },
    add(item, index) {
      // top 表示在上面添加  bottom表示下面添加
      let idx = this.index;
      if (index === "bottom") {
        idx = this.index + 1;
      }
      this.$emit("add", item, idx);
      this.visible = false;
      this.visible2 = false;
      this.visible3 = false;
    },
    close() {
      this.$emit("close");
    },
    // 文件格式错误
    handleFormatError(file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg或者png格式的图片`);
    },
    // 文件过大
    handleMaxSize(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于2M的图片`);
    },
    // 上传数量
    handleBeforeUpload1() {
      const limitNum1 = 1;
      const check1 = this.uploadList1.length < limitNum1;
      if (!check1) {
        this.$Message.warning(`最多上传${limitNum1}张图片`);
      }
      return check1;
    },
    // 上传成功
    handleSuccess1(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList1 = this.$refs.upload1.fileList;
      }
    },
    handleRemove1(file) {
      const fileList1 = this.uploadList1;
      this.uploadList1.splice(fileList1.indexOf(file), 1);
    },
    // 查看上传图片
    handleView1(name) {
      this.imgName1 = name;
      this.visible1 = true;
    },

    // 拦截上传方法
    uploadLocal() {
      this.$refs.upload1.handleClick();
    },
    // 接收素材库上传的文件
    uploadMaterial(e) {
      for (let item of e) {
        if (this.uploadList1.length >= 1) {
          this.$Message.warning(`最多上传1张图片`);
          return;
        } else {
          this.uploadList1.push({
            status: "finished",
            url: item,
          });
        }
      }
    },
    changModal(e, i) {
      this.addList[i].data = e;
      this.popperHide();
    },
    delPictureItem(index) {
      this.addList.splice(index, 1);
      this.popperHide();
    },
  },
  mounted() {
    if (this.index === 0) {
      this.visible = true;
      this.setActiveIndex(this.index);
    }
  },
};
</script>

<style scoped lang="scss">
.pictrue {
  .empty {
    font-size: 14px;
    color: #fff;
    height: 224px;
    background-color: #91c0ec;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
  }
}
.ctt1 {
  width: 100%;
  &-box {
    background-color: #fff;
    cursor: pointer;
  }
  &-poptip {
    min-height: 60px;
    .ctt1p {
      &-title {
        padding: 20px 30px;
        font-size: 14px;
        color: #333;
        border-bottom: solid 1px #ddd;
      }
      &-content {
        min-height: 400px;
        padding: 20px 22px 20px 2px;
      }
      &-item {
        display: flex;
        flex-wrap: wrap;
      }
      &-label {
        width: 100px;
        text-align: right;
      }
      &-control {
        flex: 1;
        padding-left: 5px;
      }
      &-select-templates {
        width: 140px;
        height: 130px;
        display: inline-block;
        border: 1px solid #e5e5e5;
        margin: 0 20px 15px 0;
        padding-top: 10px;
        background-color: #fff;
        text-align: center;
        cursor: pointer;
        &.active {
          border-color: #1890ff;
        }
        &__img-block {
          text-align: center;
          img {
            width: 120px;
            height: 70px;
            display: inline-block;
            vertical-align: middle;
            left: -1px;
            position: relative;
          }
        }
        p {
          margin-top: 15px;
        }
      }
      &-pic-add {
        &__title {
          font-size: 12px;
          color: #b3b3b3;
          padding-bottom: 10px;
        }
        &__btn {
          height: 100px;
          border: 1px dashed #b3b3b3;
          text-align: center;
          padding-top: 25px;
          cursor: pointer;
          color: #b3b3b3;
          width: 300px;
        }
        &__item {
          width: 300px;
          position: relative;
          &-close {
            position: absolute;
            right: -32px;
            top: 40px;
            color: #dd514c;
            font-size: 24px;
            cursor: pointer;
            &.first {
              display: none;
            }
          }
        }
      }
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}
</style>
